export default __webpack_public_path__ + "41cf96217842e115b3258298887851bb.woff";